<script>
import axios from "axios";
import {MenuPath} from "@/path";
import Swal from "sweetalert2";

export default {
  data(){
    return {
      form : {},
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    }
  },
  methods :{
    async saveMenu(){
      try {
        let res = await axios.post(this.baseUrl + MenuPath.STORE_MENU,this.form);
        if(res.data.status){
          Swal.fire('success','','success');
          this.$emit('reload');
          this.$bvModal.hide('add-modal');
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col sm="12">
          <label>Name</label>
          <b-form-input size="sm" v-model="form.name"></b-form-input>
        </b-col>
        <b-col sm="12">
          <label>Description</label>
          <b-form-textarea size="sm" v-model="form.description"></b-form-textarea>
        </b-col>
        <b-col sm="12" class="mt-4">
          <b-button @click="saveMenu" variant="primary">Save</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>

</style>